export const ERROR_MSG = {
  E0010035: '您在当前企业已被停用，请联系管理员',
  E0010125: '请使用正确的企业微信账号进行登录',
};
